import { colors } from '../../theme';

// Dynamic styles based on theme - to be used with useThemedStyles.
export const createPickerMyDayViewStyles = (theme) => ({
	container: {
		backgroundColor: theme.mainBg4,
		flex: 1,
	},
	content: {
		padding: 10,
		paddingBottom: 28,
	},
	headerCard: {
		backgroundColor: theme.mainBg1,
		borderRadius: 12,
		padding: 12,
		marginBottom: 10,
		borderWidth: 1,
		borderColor: theme.border3,
	},
	subtleText: {
		color: theme.text2,
		marginBottom: 8,
	},
	clockRow: {
		flexDirection: 'row',
		alignItems: 'center',
		flexWrap: 'wrap',
		marginBottom: 8,
	},
	clockChip: {
		marginRight: 6,
		marginBottom: 0,
	},
	employeePreviewButton: {
		marginTop: 8,
	},
	clockInCard: {
		backgroundColor: theme.mainBg1,
		borderRadius: 12,
		padding: 12,
		marginBottom: 10,
		borderWidth: 1,
		borderColor: theme.border3,
	},
	clockInTitle: {
		color: theme.text1,
		fontSize: 17,
		fontWeight: '700',
		marginBottom: 4,
	},
	clockInText: {
		color: theme.text2,
		fontSize: 13,
		marginBottom: 10,
	},
	queueControlsCard: {
		backgroundColor: theme.mainBg1,
		borderRadius: 12,
		padding: 12,
		marginBottom: 10,
		borderWidth: 1,
		borderColor: theme.border3,
	},
	pendingStockCard: {
		backgroundColor: theme.mainBg1,
		borderRadius: 12,
		padding: 12,
		marginBottom: 10,
		borderWidth: 1,
		borderColor: theme.border3,
	},
	viewModeRow: {
		flexDirection: 'row',
		marginBottom: 8,
	},
	viewModeChip: {
		borderRadius: 16,
		borderWidth: 1,
		borderColor: theme.border3,
		backgroundColor: theme.mainBg3,
		paddingVertical: 6,
		paddingHorizontal: 12,
		marginRight: 6,
	},
	viewModeChipActive: {
		backgroundColor: theme.mainBg16,
		borderColor: theme.border1,
	},
	viewModeChipText: {
		color: theme.text2,
		fontSize: 12,
		fontWeight: '600',
	},
	viewModeChipTextActive: {
		color: theme.text1,
	},
	myStatsCard: {
		borderRadius: 8,
		backgroundColor: theme.mainBg3,
		padding: 8,
		marginBottom: 8,
	},
	myStatsTitle: {
		color: theme.text1,
		fontSize: 12,
		fontWeight: '700',
		marginBottom: 2,
	},
	myStatsText: {
		color: theme.text2,
		fontSize: 12,
		marginBottom: 2,
	},
	statsRow: {
		flexDirection: 'row',
		marginBottom: 8,
	},
	statCard: {
		flex: 1,
		backgroundColor: theme.mainBg3,
		borderRadius: 8,
		paddingVertical: 8,
		paddingHorizontal: 8,
		marginHorizontal: 3,
	},
	statCardFirst: {
		marginLeft: 0,
	},
	statCardLast: {
		marginRight: 0,
	},
	statValue: {
		color: theme.text1,
		fontSize: 14,
		fontWeight: '700',
		marginBottom: 2,
	},
	statLabel: {
		color: theme.text2,
		fontSize: 11,
	},
	searchCard: {
		borderRadius: 8,
		backgroundColor: theme.mainBg2,
		padding: 8,
		marginBottom: 8,
	},
	headerActionsRow: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	listSectionHeader: {
		marginBottom: 8,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	completedSectionHeader: {
		marginTop: 14,
	},
	listSectionTitle: {
		fontSize: 15,
		fontWeight: '700',
		color: theme.text1,
	},
	emptyCard: {
		backgroundColor: theme.mainBg1,
		borderRadius: 12,
		padding: 12,
		marginBottom: 10,
		borderWidth: 1,
		borderColor: theme.border3,
	},
	routeCard: {
		backgroundColor: theme.mainBg1,
		borderRadius: 12,
		padding: 12,
		marginBottom: 10,
		borderWidth: 1,
		borderColor: theme.border3,
	},
	routeTitleLine: {
		flexDirection: 'row',
		alignItems: 'flex-start',
		justifyContent: 'space-between',
		marginBottom: 3,
	},
	routeTitle: {
		color: theme.text1,
		fontSize: 17,
		fontWeight: '700',
		flex: 1,
		paddingRight: 8,
	},
	routePlanned: {
		color: theme.text1,
		fontSize: 13,
		fontWeight: '600',
		marginBottom: 7,
	},
	routeMetaLine: {
		flexDirection: 'row',
		alignItems: 'flex-start',
		marginBottom: 3,
	},
	routeMetaLabel: {
		color: theme.text2,
		fontSize: 12,
		fontWeight: '700',
		width: 58,
	},
	routeMeta: {
		color: theme.text2,
		fontSize: 13,
		flex: 1,
	},
	machineCard: {
		backgroundColor: theme.mainBg2,
		borderRadius: 10,
		padding: 10,
		marginTop: 8,
		borderWidth: 1,
		borderColor: theme.border3,
	},
	rowCardPending: {
		borderLeftWidth: 4,
		borderLeftColor: theme.info1,
	},
	rowCardPartiallyPicked: {
		borderLeftWidth: 4,
		borderLeftColor: theme.warning1 || theme.info1,
	},
	rowCardLabelOnly: {
		borderLeftWidth: 4,
		borderLeftColor: theme.primary1,
	},
	rowCardDone: {
		borderLeftWidth: 4,
		borderLeftColor: theme.success1,
	},
	machineCardViewOnly: {
		backgroundColor: theme.mainBg3,
		borderLeftColor: theme.border3,
		opacity: 0.5,
	},
	pickingLabels: {
		backgroundColor: colors.YELLOW[5],
		borderColor: colors.YELLOW[2],
		borderRadius: 7,
		borderWidth: 1,
		marginBottom: 9,
		paddingHorizontal: 9,
		paddingVertical: 7,
	},
	pickingLabelsTitle: {
		color: colors.YELLOW[0],
		fontSize: 11,
		fontWeight: '800',
		letterSpacing: 0.5,
		marginBottom: 5,
		textTransform: 'uppercase',
	},
	pickingLabelsList: {
		flexDirection: 'row',
		flexWrap: 'wrap',
	},
	pickingLabelChip: {
		backgroundColor: colors.YELLOW[3],
		borderRadius: 5,
		marginBottom: 3,
		marginRight: 5,
		maxWidth: '100%',
		paddingHorizontal: 8,
		paddingVertical: 4,
	},
	pickingLabelText: {
		color: colors.GREY[0],
		flexShrink: 1,
		fontSize: 15,
		fontWeight: '800',
	},
	machineTitleLine: {
		flexDirection: 'row',
		alignItems: 'flex-start',
	},
	orderBadge: {
		width: 26,
		height: 26,
		borderRadius: 13,
		backgroundColor: theme.mainBg16,
		alignItems: 'center',
		justifyContent: 'center',
		marginRight: 8,
	},
	orderBadgeText: {
		color: theme.text1,
		fontSize: 12,
		fontWeight: '700',
	},
	machineTitleContent: {
		flex: 1,
		paddingRight: 8,
	},
	machineName: {
		color: theme.text1,
		fontSize: 14,
		fontWeight: '600',
		marginBottom: 2,
	},
	machineLocation: {
		color: theme.text2,
		fontSize: 12,
	},
	machineAssignmentLine: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginTop: 8,
	},
	machineActionText: {
		color: theme.text2,
		fontSize: 12,
		fontWeight: '600',
	},
	rowTitleLine: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: 6,
	},
	rowTitle: {
		color: theme.text1,
		fontSize: 15,
		fontWeight: '600',
		flex: 1,
		paddingRight: 8,
	},
	rowMeta: {
		color: theme.text2,
		fontSize: 13,
		marginBottom: 2,
	},
});
